<template>
  <div>
    <sv-header :asset="asset" title="Tarieven" />
    <v-container grid-list-xl>
      <sv-page-title title="Keuze uit onderstaande behandelingen" />
      <v-layout align-space-around justify-center row wrap fill-height>
        <v-flex xs12 sm4 v-for="(dienst, index) in diensten" :key="`dienst${index}`">
          <v-card class="elevation-6 mb-3">
            <v-card-title
              class="primary white--text title font-weight-regular text-truncate"
            >{{dienst.name}}</v-card-title>
            <v-card-text style="min-height: 180px;">
              <v-container fluid grid-list-xs>
                <v-layout row wrap>
                  <template v-for="(tarief, index2) in dienst.tarieven">
                    <v-flex
                      xs6
                      :key="`1dienst${index}tarief${index2}`"
                      class="subheading text-xs-right"
                      v-text="getPrefixOrMin(tarief)"
                    >{{tarief.min}} min:</v-flex>
                    <v-flex
                      xs6
                      :key="`2dienst${index}tarief${index2}`"
                      class="subheading text-xs-left"
                    >
                      <editable-field :field-id="tarief.fieldId" v-if="fields"></editable-field>
                    </v-flex>
                    <p
                      :key="`3dienst${index}tarief${index2}`"
                      class="font-italic caption"
                      v-if="tarief.description"
                    >{{tarief.description}}</p>
                  </template>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mb-2 white--text" :to="{name:dienst.link}">Lees meer</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  computed: {
    asset() {
      return require("@/assets/sv/headers/tarieven.jpg");
    },
    diensten() {
      return this.$store.getters.diensten;
    },
    fields() {
      return this.$store.getters.fields;
    }
  },
  methods: {
    getPrefixOrMin(tarief) {
      if (tarief) {
        return tarief.prefix ? tarief.prefix : `${tarief.min} min:`;
      }
    }
  }
};
</script>

<style lang="scss">
</style>
